import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-supervisor-nfa-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './nfa-tab.component.html',
  providers: [{ provide: TabComponent, useExisting: SupervisorNfaTabComponent }],
})
export class SupervisorNfaTabComponent extends TabComponent {
  override name = this.dictionaryService.get('NFA');

  userId = input.required<string>();
  endpoint = computed(() => `/visits/tables/supervisors-nfa/${this.userId()}`);

  public async main(): Promise<void> {}
}
